import { render } from "./footpic.vue?vue&type=template&id=7d9c4760"
import script from "./footpic.vue?vue&type=script&lang=js"
export * from "./footpic.vue?vue&type=script&lang=js"
script.render = render

export default script